import type { FirebaseOptions } from 'firebase/app'
import { initializeApp } from 'firebase/app'
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check'
import type { FirebaseApp } from '@firebase/app-types'

const firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyD9lK5GCZWSyTE-Vbko9hMh42NFFNHQsJ4',
  appId: '1:986761509316:web:69b19c13cdc0e01520cc91',
  projectId: 'return-lottery',
  authDomain: 'return-lottery.firebaseapp.com'
}
const APP_CHECK_KEY = '6Lde7K0rAAAAAJhRwU6A6s66Ku48hPyOFaLvLsqH'

let app: FirebaseApp | null = null

export function ensureFirebase() {
  if (!app) {
    app = initializeApp(firebaseConfig) as FirebaseApp
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(APP_CHECK_KEY),
      isTokenAutoRefreshEnabled: true
    })
    return app
  } else {
    return app
  }
}
